export default __webpack_public_path__ + "static/media/bin.e9496b8c.svg";